import * as Yup from 'yup'

import { formValidationSchemaNoChanged } from '../../../Form'
import {
  getValidator,
  PROFILE_CONTACTS_WIDGET_VALUE_FIELD,
} from '../ProfileContactsWidgetListCell'

export function getValidationSchema({ initialValues, t, typeConfig }) {
  return Yup.object({
    [PROFILE_CONTACTS_WIDGET_VALUE_FIELD]: getValidator({
      isCreate: false,
      t,
      typeConfig,
    }),
  }).concat(formValidationSchemaNoChanged({ initialValues }))
}
